'use client';

import selectProductTitleTrigger from '@coolblue-development/ga4-events/triggers/AddToCartPage/selectProductTitleTrigger';
import { useAnalytics } from '@coolblue-development/next-analytics/client';
import { useSummaryStore } from '@features/add-to-cart-page/components/SummaryStore';
import React from 'react';

type Props = {
  id: number;
  href: string;
  children: React.ReactNode;
};

export default function ProductLink({ children, id, href }: Props) {
  const { trackEvent } = useAnalytics();
  const { trackingSubFeature } = useSummaryStore();

  function onClick() {
    trackEvent(
      selectProductTitleTrigger({
        sub_feature:
          (trackingSubFeature as Parameters<typeof selectProductTitleTrigger>[0]['sub_feature']) ||
          'customer_atc_page',
        index: 1,
        total_indices: 1,
        method: 'image',
        item_id: id
      })
    );
  }

  return (
    /* Hidden from screen readers as the product title link provides the same navigation */
    <a href={href} onClick={onClick} tabIndex={-1} aria-hidden='true'>
      {children}
    </a>
  );
}
